{
  "title": "Cola de Desviación",
  "tabs": {
    "needsAction": "Requiere Acción",
    "singleBreach": "Incumplimiento Único",
    "compoundBreach": "Incumplimiento Compuesto"
  },
  "table": {
    "portfolio": "Cartera",
    "household": "Grupo Familiar",
    "accountType": "Tipo de Cuenta",
    "reason": "Motivo",
    "custodian": "Custodio",
    "value": "Valor",
    "cashAndPosition": "Efectivo / Posición",
    "cashShort": "Efectivo",
    "positionShort": "Pos.",
    "staleTooltip": "Datos obsoletos — a partir del {{date}}",
    "positionUnavailable": "Desviación de posición no disponible"
  },
  "empty": {
    "title": "Ninguna cuenta requiere acción hoy.",
    "filterNoResults": "Ninguna cuenta coincide con este filtro."
  },
  "footer": {
    "rowCount": "Mostrando {{shown}} de {{total}} cuentas que requieren acción"
  },
  "legend": {
    "title": "Leyenda",
    "singleBreach": "Incumplimiento Único",
    "compoundBreach": "Incumplimiento Compuesto",
    "stale": "Datos Obsoletos",
    "international": "Tenencias Internacionales"
  },
  "lastRefresh": {
    "label": "A partir del {{value}}"
  },
  "header": {
    "queueAlertLabel": "{{count}} en cola",
    "queueAlertA11yLabel": "{{count}} cuentas en la cola de acción",
    "viewAll": "Ver Todo"
  },
  "breaches": {
    "liquidation": "Liquidación",
    "transfer": "Transferencia",
    "drift": "Desviación",
    "unverified_one": "{{count}} Sin verificar",
    "unverified_other": "{{count}} Sin verificar",
    "pending_one": "{{count}} Pendiente",
    "pending_other": "{{count}} Pendientes"
  }
}
